import PropTypes from 'prop-types';

var propTypes = {
    applicationName: PropTypes.string.isRequired,
    currentPageName: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    photoUrl: PropTypes.string,
    avatarColor: PropTypes.string,
    userNameInitials: PropTypes.string.isRequired,
    userAddress: PropTypes.string,
    userInfo: PropTypes.string,
    isLoading: PropTypes.bool,
    toggleMainMenu: PropTypes.func.isRequired,
    toggleSettingsMenu: PropTypes.func.isRequired,
    toggleVerticalsMenu: PropTypes.func.isRequired,
    className: PropTypes.string,
    classNames: PropTypes.shape({
        LeftNavHeader: PropTypes.string,
        LeftNavHeaderUserDetails: PropTypes.string,
        UserDetails: PropTypes.string,
        UserDetailsAvatar: PropTypes.string,
    }),
    primaryAction: PropTypes.node,
    secondaryActions: PropTypes.node,
};
var defaultProps = {
    applicationName: 'WARNING: VERTICAL NAME',
    currentPageName: 'WARNING: CURRENT PAGE NAME',
    userName: 'WARNING: USER NAME',
    userNameInitials: 'W',
    userAddress: 'WARNING: USER ADDRESS',
    isLoading: false,
};

export { defaultProps, propTypes };
